




import Vue from 'vue';
import { mapState } from 'vuex';
import { ILookupType, LocationLookupType } from '@/Stores/LookupStore';

export default Vue.extend({
    name: 'LocationLookupViewer',
    props: {
        location: { type: String },
        type: {
            validator: (value: keyof typeof LocationLookupType) => {
                if (LocationLookupType[value] || LocationLookupType[value] === 0) {
                    return true;
                }
                return false;
            },
        },
        value: {
            required: true,
        },
    },
    beforeMount() {
        this.$typedStore.modules.lookupsModule.actions.getLocationLookups({
            location: this.location,
            lookupType: this.lookupType
        });
    },
    computed: {
        ...mapState({
            lookups(state: any): { [code: string]: ILookupType } {
                if (!this.location) {
                    return {};
                }

                const loc = state.lookupsModule.locationLookups;

                if (!loc[this.location]) {
                    return {};
                }

                const types = loc[this.location][this.lookupType];

                if (!types) {
                    return {};
                }

                return types;
            }
        }),
        lookupName(): string {
            return this.lookups[this.value as any]?.name || '';
        },
        lookupType(): LocationLookupType {
            if (typeof this.type === 'string') {
                return LocationLookupType[this.type];
            }
            return this.type;
        },
    },
    watch: {
        location(newLocation: string) {
            this.$typedStore.modules.lookupsModule.actions.getLocationLookups({
                location: this.location,
                lookupType: this.lookupType
            });
        }
    },
});
